import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import logo from '../../logo-qb.svg'
import { CardWrapper, CardHeader, CardBody } from '../Card'
import { LoginBox } from './LoginBox'

export const Login = (props) => {
  const { children, header, message, boxOnly, type } = props
  useEffect(() => {
    if (!boxOnly) {
      document.body.classList.add('login-page')
      document.body.style.removeProperty('height')
      return () => {
        document.body.classList.remove('login-page')
      }
    }
  })
  return (
    <LoginBox>
      <img id='logo_login' className='login-logo' src={logo} alt='logo' />
      <CardWrapper outline type={type}>
        <CardHeader center>{header}</CardHeader>
        <CardBody>
          <p className='login-box-msg'>{message}</p>
          {children}
        </CardBody>
      </CardWrapper>
    </LoginBox>
  )
}
Login.propTypes = {
  children: PropTypes.node,
  header: PropTypes.node,
  title: PropTypes.string,
  message: PropTypes.string,
  boxOnly: PropTypes.bool,
  type: PropTypes.string
}
Login.defaultProps = {
  children: null,
  title: '',
  message: '',
  boxOnly: false,
  header: null,
  type: 'secondary'
}
